<script lang="ts">
	import { Button, ButtonType, ToastType } from '@repo/commons/components'
	import { showToast } from '@repo/commons/utils'
	import { t } from 'svelte-i18n'

	type Props = {
		toastsStore?: any
		showTableTopDeleteButton?: boolean
		showTableTopNewProjectButton?: boolean
		selectedRowsSet?: Set<any>
		onDeleteButtonClicked?: ((rowIdsToDelete: Set<any>) => void) | null
		onNewProjectButtonClicked?: (() => void) | null
	}
	const {
		toastsStore = null,
		showTableTopDeleteButton = true,
		showTableTopNewProjectButton = true,
		selectedRowsSet = new Set<any>(),
		onDeleteButtonClicked = null,
		onNewProjectButtonClicked = null
	}: Props = $props()
</script>

<div class="top-buttons-container">
	{#if showTableTopDeleteButton}
		<div class="delete-button">
			<Button
				buttonText={'Delete'}
				buttonType={ButtonType.DESTRUCTIVE}
				onclick={() => {
					if (selectedRowsSet.size === 0) {
						showToast(toastsStore, {
							message: $t('no_rows_selected'),
							type: ToastType.ERROR
						})
						return
					}
					onDeleteButtonClicked?.(selectedRowsSet)
				}}
			/>
		</div>
	{/if}
	{#if showTableTopNewProjectButton}
		<div class="new-project-button">
			<Button
				buttonText={'New Project'}
				buttonType={ButtonType.BRAND}
				onclick={() => {
					onNewProjectButtonClicked?.()
				}}
			/>
		</div>
	{/if}
</div>

<style lang="postcss">
	.delete-button,
	.new-project-button {
		@apply mb-4 ms-2;
	}

	.top-buttons-container {
		@apply flex flex-row items-center;
	}
</style>
